const REJECT_TTL_MS = 30 * 60 * 1000; // 30 minutos

class VoiceService {
  idsatendimentoToReject = new Map(); // id -> timestamp

  _isExpired(timestamp) {
    return Date.now() - timestamp > REJECT_TTL_MS;
  }

  _purgeExpired() {
    for (const [id, timestamp] of this.idsatendimentoToReject) {
      if (this._isExpired(timestamp)) {
        this.idsatendimentoToReject.delete(id);
      }
    }
  }

  addIdAtendimentoToRejectIdsList(idatendimento) {
    this._purgeExpired();
    this.idsatendimentoToReject.set(parseInt(idatendimento), Date.now());
  }

  removeIdAtendimentoToRejectIdsList(idatendimento) {
    this.idsatendimentoToReject.delete(parseInt(idatendimento));
  }

  clearIdsAtendimentoToRejectIdsList() {
    this.idsatendimentoToReject.clear();
  }

  isThisIdAtendimentoToBeReject(idatendimento) {
    return this.idsatendimentoToReject.has(parseInt(idatendimento));
  }

  getIdatendimentoByEvt(dest, direction, infoserv) {
    try {
      if (
        dest.split("/")[0] != "sigilo" &&
        dest.split("/")[0] != "itv" &&
        dest.split("/")[0] != "itw"
      ) {
        if (direction == 2) {
          var infoserv2 = infoserv.split("-");

          if (infoserv2.length > 10) {
            var [idatendimento, sip, telefone] = infoserv.split("-");
            return idatendimento;
          } else {
            var [telefone, sip, idatendimento] = infoserv.split("-");

            return idatendimento;
          }
        } else {
          if (infoserv.search("=") != -1) {
            var strContato = infoserv.split("-");
            var [idatendimento, idservico, quemtransferiu, infocomp] =
              infoserv.split("-");

            return idatendimento;
          } else {
            //infoserv = '95487-4-3700+71982718640-s-1-1-1-1-1-1-1-2-0-1-1-1-0-13-2-';
            var strContato = infoserv.split("-");

            //CAMPANHA
            //95487-4-3700+71982718640-s-1-1-1-1-1-1-1-2-0-1-1-1-0-13-2-;

            //RECEPTIVO
            //95489-1-71996390675+4672-RafaelTeste+1++0-1-1-1-1-1-1-1-1-1-1-0-1-156-

            if (parseInt(strContato[11]) === 1) {
              var [idatendimento, idservico, telefone] = infoserv.split("-");
              return idatendimento;

              //227132-1-71996390675+3710-Rafael_3710+1++0-1-1-1-1-1-1-1-1-1-1-0-1-365-
            } else if (parseInt(strContato[11]) === 2) {
              var [idatendimento, idservico, telefone, infosub] =
                infoserv.split("-");
              return idatendimento;
              //var [nomeousub, iddb, onumber] = "";
            }
          }
        }
      }
    } catch (error) {}
  }
}

export const voiceService = new VoiceService();
